<template>
  <div>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex
        v-for="(item, i) in getImagePerPage"
        v-bind="{ [`xs${3 * 2}`]: true, [`sm${3}`]: true, [`md${3}`]: true, [`lg${3}`]: true }"
        :key="i"
        @click="showImage(i)"
      >
        <v-card hover raised height="120">
          <!-- <VueLightbox
            :src="item.fullimgpath"
            :caption="item.caption"
            album="Jade Image Gallery"> --> 
          <v-card-media
          :src="item.image"
          height="120"
          >
          </v-card-media>
          <!-- </VueLightbox>  -->
        </v-card>
      </v-flex>
      <!-- <img class="image" v-for="(image, i) in images" :src="image" @click="index = i">  -->
      <!-- <vue-gallery-slideshow :images="thumbnail" :index="index" @close="index = null"></vue-gallery-slideshow> -->
      <BuzzGallery v-if="isShowGallery" @showGallery="isShowGallery=!isShowGallery" :images="thumbnail" :activeIndex="index"/>
    </v-layout>
  </v-container>
  <v-container>
    <v-layout row wrap justify-center>
      <v-pagination :length="Math.ceil(thumbnail.length/imagesPerPage)" v-model="page" circle></v-pagination>
    </v-layout>
  </v-container>
  </div>
</template>

<script>
import BuzzGallery from '@/components/BuzzGallery'

export default {
  props: {
    thumbnail: {
      required: true,
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      page: 1,
      imagesPerPage: 12,
      index: 0,
      isShowGallery: false
    }
  },
  components: {
    BuzzGallery
  },
  computed: {
    getImagePerPage: function () {
      return this.thumbnail.slice(((this.page - 1) * this.imagesPerPage), (this.imagesPerPage * this.page))
    }
  },
  methods: {
    showImage (image) {
      if (this.page === 1) {
        this.index = image
      } else {
        this.index = this.imagesPerPage * (this.page - 1) + image
      }
      this.isShowGallery = !this.isShowGallery
    }
  }
}
</script>

<style scoped>
.thumb {
  position: relative;
  margin-bottom: 30px;
  width: 100%;
  /*height: 150px;*/
  text-align: center; 
}
.thumbimage {
  /*max-height: 150px;*/
  /*max-width: 150px;*/
  max-width: 100%;
  max-height: 100%;
  padding: 10px;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageGallery.vue